import { createContext, PropsWithChildren, useState } from "react";

import { ButtonType } from "@/lib/types/Button";

export type PageHeaderConfig = {
  iconName?: string;
  buttons?: ButtonType[];
  snippetEmoji?: string;
  snippetColor?: string;
  title?: string | React.ReactNode;
  onBack?: () => void;
};

type PageHeaderContextType = {
  config: PageHeaderConfig;
  setConfig: (config: PageHeaderConfig) => void;
};

export const PageHeaderContext = createContext<PageHeaderContextType>({
  config: {},
  setConfig: () => undefined,
});

export const PageHeaderProvider = ({
  children,
}: PropsWithChildren): JSX.Element => {
  const [config, setConfig] = useState<PageHeaderConfig>({});

  return (
    <PageHeaderContext.Provider value={{ config, setConfig }}>
      {children}
    </PageHeaderContext.Provider>
  );
};
